<template><div class="pagearea">
    <div class="notice" v-loading="loadingDiv" :style="{ height: height + 'px' }" >
        <div class="title">公告</div>
        <div class="list" v-for="(item,index) in list" :key="index">
            <span style="cursor:pointer"  @click="$router.push({ path:'/details',query:{ id:item.id }})">{{ item.contentTitle }}</span>
            <span>{{ item.createTime }}</span>
        </div>
           
    </div><pagination ref="pagination" :defaultPageSize="params.pageSize" :current="params.pageNum" :total="total" @getList="getList"></pagination> 
</div>    
</template>
<script>
export default {
   data(){
       return{
          params:{
            pageNum:1,
            pageSize:12
          },
          total:0,
          page:1,
          height:'',
          loadingDiv:false,
          list:[]
       }
   },
   created(){
       this.height = document.body.clientHeight - 315;
       this.getList(1);
   },
   methods:{
    getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
        getDataList(){
           this.loadingDiv = true;
           this.$https.get('/portal/index/getNoticeList',{params:this.params}).then(res=>{
           this.loadingDiv = false;
              if(res.code == 200){
                    this.list = res.rows;
                    this.total = Number(res.total);
                }else{
                    this.$message.error(res.msg);
                }
           })
       }
   }
}
</script>

<style lang="less" scoped>
.notice{min-height: 530px;
   background: #fff;
   width: 1300px;
   margin:0 auto;
   padding: 20px;
   .list{
       display: flex;
       justify-content: space-between;
       border-bottom:1px solid #eeeeee;
       line-height: 40px;
   }
}
.pagearea{
   background: #fff;
   width: 1300px;
   margin:0 auto;
   padding: 20px 0;
    
}
</style>